import * as React from "react";
import { singleton } from "logic/singleton";
const HotkeysContext = React.createContext(void 0);
export default singleton("contexts.HotkeysContext", () => HotkeysContext);
